import React from "react";
import images from "components/images";

const Teamspeak = () => (
  <a href="ts3server://ts3.combinedarms.co.uk">
    <img src={images["TSLogo"]} width="216" height="65" alt={"teamspeak"} />
  </a>
);

export default Teamspeak;
